import { Component, Directive, OnInit, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'key-value-row',
  templateUrl: './key-value-row.component.html',
  styleUrls: ['./key-value-row.component.scss'],
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'row mt-4 mb-4'
  }
})
export class KeyValueRowComponent implements OnInit {

  constructor() { }

  ngOnInit() { }
}

@Component({
  selector: 'key-value',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'col text-center self-align-center'
  },
  template: `<div>
  <h2 *ngIf="value; else noData"><b>{{ value }}</b></h2>
  <h6 class="text-bold">{{ key }}</h6>
  <ng-template #noData><h2>&nbsp;</h2></ng-template>
</div>
`
})
export class KeyValueComponent {
  @Input() key: string;
  @Input() value: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/components/assorted/key-value-row.component.ts